const CheckIcon = ({className =""   }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <rect width="40" height="40" rx="20" fill="#FE5900" />
        <path
            d="M11 22.1428L16.1429 27.2856L29 14.4285"
            stroke="white"
            strokeWidth="2.57143"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const BubbleIcon = ({className = ""}) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <rect width="40" height="40" rx="20" fill="#FE5900" />
        <g clipPath="url(#clip0)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2 27.2C22.5255 27.2 23.6 28.2745 23.6 29.6C23.6 30.9255 22.5255 32 21.2 32C19.8745 32 18.8 30.9255 18.8 29.6C18.8 28.2745 19.8745 27.2 21.2 27.2ZM13.6895 23.6C15.3463 23.6 16.6895 24.9431 16.6895 26.6C16.6895 28.2569 15.3463 29.6 13.6895 29.6C12.0326 29.6 10.6895 28.2569 10.6895 26.6C10.6895 24.9431 12.0326 23.6 13.6895 23.6ZM27.5832 24.2C28.9087 24.2 29.9832 25.2745 29.9832 26.6C29.9832 27.9255 28.9087 29 27.5832 29C26.2577 29 25.1832 27.9255 25.1832 26.6C25.1832 25.2745 26.2577 24.2 27.5832 24.2ZM30.2 19.1822C31.1941 19.1822 32 19.9881 32 20.9822C32 21.9764 31.1941 22.7822 30.2 22.7822C29.2059 22.7822 28.4 21.9764 28.4 20.9822C28.4 19.9881 29.2059 19.1822 30.2 19.1822ZM11 15.2C12.6569 15.2 14 16.5431 14 18.2C14 19.8569 12.6569 21.2 11 21.2C9.34315 21.2 8 19.8569 8 18.2C8 16.5431 9.34315 15.2 11 15.2ZM29.3429 14.2487C30.0057 14.2487 30.5429 14.786 30.5429 15.4487C30.5429 16.1114 30.0057 16.6487 29.3429 16.6487C28.6802 16.6487 28.1429 16.1114 28.1429 15.4487C28.1429 14.786 28.6802 14.2487 29.3429 14.2487ZM17.6 8C19.5882 8 21.2 9.61177 21.2 11.6C21.2 13.5882 19.5882 15.2 17.6 15.2C15.6118 15.2 14 13.5882 14 11.6C14 9.61177 15.6118 8 17.6 8ZM26.6 11.6C26.9314 11.6 27.2 11.8686 27.2 12.2C27.2 12.5314 26.9314 12.8 26.6 12.8C26.2686 12.8 26 12.5314 26 12.2C26 11.8686 26.2686 11.6 26.6 11.6Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="24" height="24" fill="white" transform="translate(8 8)" />
            </clipPath>
        </defs>
    </svg>
);

export { CheckIcon, BubbleIcon };
